import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import useAuthStore from '../store/authStore';

const cor = '#B51013';

const PASSOS = [
  { icon: '👋', titulo: 'Bem-vindo ao Jatear LMS!', desc: 'Esta é a plataforma de treinamentos da Jatear. Aqui você acompanha e realiza todos os seus treinamentos obrigatórios.' },
  { icon: '📋', titulo: 'Seus treinamentos', desc: 'Em "Meus treinamentos" você vê todos os cursos obrigatórios para a sua função, organizados em Pendentes, Vencidos e Concluídos.' },
  { icon: '🎓', titulo: 'Realize os cursos', desc: 'Acesse a "Biblioteca de cursos", clique em qualquer treinamento e responda a avaliação. Ao passar com nota 7+, você ganha um certificado!' },
  { icon: '🏆', titulo: 'Ganhe pontos e badges', desc: 'Cada treinamento concluído vale pontos. Acompanhe sua evolução, conquiste badges e compare com a equipe no ranking.' },
  { icon: '🔔', titulo: 'Fique atento às notificações', desc: 'O sininho avisa quando um treinamento está vencendo. Configure seu perfil para deixar tudo em dia.' },
];

export default function OnboardingColab() {
  const usuario = useAuthStore((s) => s.usuario);
  const navigate = useNavigate();
  const [visivel, setVisivel] = useState(false);
  const [passo, setPasso] = useState(0);

  useEffect(() => {
    if (!usuario) return;
    const chave = `onboarding_${usuario.uid}`;
    if (localStorage.getItem(chave)) return;

    getDoc(doc(db, 'progresso', usuario.uid)).then(snap => {
      if (!snap.exists() || Object.keys(snap.data().treinamentos || {}).length === 0) {
        setVisivel(true);
      }
    }).catch(() => {});
  }, [usuario]);

  const fechar = (irParaTreinamentos = false) => {
    localStorage.setItem(`onboarding_${usuario?.uid}`, '1');
    setVisivel(false);
    if (irParaTreinamentos) navigate('/meus-treinamentos');
  };

  if (!visivel) return null;

  const atual = PASSOS[passo];
  const ultimo = passo === PASSOS.length - 1;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9994, padding: '16px' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', maxWidth: '440px', width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        {/* Progress dots */}
        <div style={{ display: 'flex', gap: '6px', justifyContent: 'center', marginBottom: '24px' }}>
          {PASSOS.map((_, i) => (
            <div key={i} style={{ width: i === passo ? '20px' : '8px', height: '8px', borderRadius: '4px', background: i === passo ? cor : '#e0e0e0', transition: 'all 0.3s' }} />
          ))}
        </div>

        <div style={{ fontSize: '44px', marginBottom: '14px' }}>{atual.icon}</div>
        <div style={{ fontSize: '18px', fontWeight: '800', color: '#1a1a1a', marginBottom: '10px' }}>{atual.titulo}</div>
        <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.6', marginBottom: '28px' }}>{atual.desc}</div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button onClick={() => fechar(false)} style={{ padding: '10px 18px', background: 'none', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', color: '#888', cursor: 'pointer' }}>
            Pular
          </button>
          {!ultimo ? (
            <button onClick={() => setPasso(p => p + 1)} style={{ padding: '10px 24px', background: cor, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
              Próximo →
            </button>
          ) : (
            <button onClick={() => fechar(true)} style={{ padding: '10px 24px', background: cor, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
              Ver meus treinamentos 🚀
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
